import { render } from "./TraineeChooseTaskAssessmentModal.vue?vue&type=template&id=4a051f50&scoped=true"
import script from "./TraineeChooseTaskAssessmentModal.vue?vue&type=script&lang=js"
export * from "./TraineeChooseTaskAssessmentModal.vue?vue&type=script&lang=js"

import "./TraineeChooseTaskAssessmentModal.vue?vue&type=style&index=0&id=4a051f50&scoped=true&lang=css"
/* custom blocks */
import block0 from "./TraineeChooseTaskAssessmentModal.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a051f50"]])

export default __exports__